import { Member } from '@nextforce/api'
import { makeStyles } from '@rneui/themed'
import React, { useRef } from 'react'
import { View } from 'react-native'
import { FlatList } from 'react-native-gesture-handler'
import { MEMBER_SLUG_WIDTH, MemberSlug } from './slug'

interface Props {
  members: Member[] | undefined
  onMemberRemoved?(member: Member): void
}

export function MemberSlugList({ members, onMemberRemoved }: Props) {
  const styles = useStyles()
  const list = useRef<FlatList | null>(null)

  return (
    <View>
      <FlatList
        style={styles.container}
        data={members}
        renderItem={({ item }) => (
          <MemberSlug member={item} onRemoved={onMemberRemoved} />
        )}
        keyExtractor={(item: Member) => String(item.id)}
        horizontal
        getItemLayout={(_, index) => ({
          length: MEMBER_SLUG_WIDTH,
          offset: MEMBER_SLUG_WIDTH * index,
          index,
        })}
        onContentSizeChange={() =>
          list.current?.scrollToEnd({ animated: true })
        }
        ref={ref => {
          list.current = ref
        }}
      />
    </View>
  )
}

const useStyles = makeStyles(theme => ({
  container: {
    flexGrow: 0,
    height: 80,
  },
}))
